<template>
    <div class="c-wrapper">
        <div class="c-label">{{ label }}</div>
        <div v-if="showTooltip" class="custom-info">
            <img class="ico" src="@/assets/images/info-icon.svg" alt="info" @click="toggleShowTooltip" />
            <div
                v-if="isShowTooltip"
                class="custom-tooltip"
                v-click-outside="closeTooltip"
            >
                <div class="custom-tooltip__title">{{ tooltipTitle }}</div>
                <div class="custom-tooltip__desc">
                    {{ tooltipDesc }}
                </div>
                <i
                    class="fa fa-times-circle custom-tooltip__close"
                    aria-hidden="true"
                    @click="closeTooltip"
                ></i>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'FormLabel',
    props: {
        label: String,
        showTooltip: Boolean,
        tooltipTitle: String,
        tooltipDesc: String,
    },
    data() {
        return {
            isShowTooltip: false,
        };
    },
    methods: {
        toggleShowTooltip() {
            this.isShowTooltip = !this.isShowTooltip;
        },
        closeTooltip() {
            this.isShowTooltip = false;
        },
    },
};
</script>

<style lang="scss" scoped>
.c-wrapper {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-block: 33px;
}
.c-label {
    font-size: 20px;
    line-height: 24px;
    color: #555e67;
}
.custom-info {
    position: relative;
    .ico {
        color: #7bbdef;
        font-size: 20px;
        cursor: pointer;
    }
}
.custom-tooltip {
    position: absolute;
    border-radius: 30px;
    background: #edf5f7;
    box-shadow: 0px 13px 30px -12px rgba(0, 0, 0, 0.25);
    min-width: 400px;
    padding: 20px;
    z-index: 10;
    transform: translate(-100px, -60px);

    &__title {
        font-size: 16px;
        font-weight: 600;
        line-height: 24px; /* 150% */
        color: #41b8dc;
        margin-bottom: 8px;
    }

    &__desc {
        font-size: 16px;
        line-height: 24px; /* 150% */
        color: #7c7c7a;
    }

    &__close {
        position: absolute;
        right: 16px;
        top: 8px;
        color: #2178ab !important;
        cursor: pointer;
    }
}
</style>
